import React from 'react'
import { styled } from '@mui/material/styles'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { useIntl } from 'react-intl'

const StyledDialogContent = styled(DialogContent)({
  minWidth: '400px',
  maxWidth: '600px',
})

const ObservationText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'hasObservation',
})(({ theme, hasObservation }) =>
  hasObservation
    ? {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        lineHeight: 1.6,
      }
    : {
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
      }
)

export const ObservationsDialog = ({ open, onClose, observaciones_sspp }) => {
  const intl = useIntl()

  const title =
    intl.formatMessage({
      id: 'pages.application.detail.history.tableFields.observaciones',
    }) || 'Observaciones'

  const closeButtonText = intl.formatMessage({
    id: 'global.close',
  })

  const hasObservation = !!observaciones_sspp

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <StyledDialogContent>
        <ObservationText hasObservation={hasObservation}>
          {observaciones_sspp || 'Sin observaciones'}
        </ObservationText>
      </StyledDialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {closeButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
